export const socialMedia = {
  facebook: "https://www.facebook.com/",
  github: "https://github.com/",
  twitter: "https://twitter.com",
};